import ProductDetailAboveProductDetailImagesHook from 'themes/base/components/product/ProductDetailAboveProductDetailImagesHook'
import ProductPurchasedPerMonthBanner from '@theme/components/product/ProductPurchasedPerMonthBanner'

export default {
  extends: ProductDetailAboveProductDetailImagesHook,
  name: 'ProductDetailAboveProductDetailImagesHook',
  components: { ProductPurchasedPerMonthBanner },
  props: {
    product: Object,
    displayedVariant: Object,
  },
}
